import { ApiProject } from "@incendium/api";
import { Box, Typography } from "@mui/material";
import ProjectCodeSnippet from "features/project/components/ProjectCodeSnippet";
import DatalayerSycCard from "features/dataConnectors/components/DatalayerSycCard";

interface IOnboardingSPAProps {
  project: ApiProject;
}

function OnboardingSPA({ project }: IOnboardingSPAProps) {
  return (
    <div>
      <Typography variant="subtitle1" mb={1}>
        How to Install the Incendium Pixel on a Single Page Application (SPA)
        like Next.js
      </Typography>
      <Typography variant="body1">
        You can add the Incendium Pixel to your site manually or via Google Tag
        Manager (GTM).
      </Typography>
      <Typography variant="body1" mb={2}>
        Copy the Incendium Pixel code and paste it before the closing{" "}
        {"</head>"} tag on your site or add it in Google Tag Manager (GTM).
      </Typography>
      <ProjectCodeSnippet project={project} />
      <Typography variant="body1" mt={2}>
        Since SPAs don’t trigger full page reloads, you need additional logic to
        track navigation events properly.
      </Typography>
      <Typography variant="body1" mt={2}>
        <strong>Option 1: Use a DataLayer (Recommended)</strong>
        <br /> If you're already using a dataLayer, simply enable Track
        Pageviews with Data Layer in GTM to ensure correct tracking.
      </Typography>
      <Box sx={{ width: 450 }} my={2}>
        <DatalayerSycCard />
      </Box>
      <Typography variant="body1">
        <strong>Option 2: Fire the Pixel on Every Page Navigation</strong>
        <br /> If you’re not using a dataLayer, you must manually trigger the
        Incendium Pixel on each page navigation. In Next.js, you can achieve
        this by listening to route changes in _app.js or a global event: then
        running this javascript <code>inc("run");</code>
      </Typography>
    </div>
  );
}

export default OnboardingSPA;
